import { Cliente } from "src/app/modules/painel/modules/clientes/interfaces/cliente";
import { Prestador } from "src/app/modules/painel/modules/prestadores/interfaces/prestador";
import { Role } from "src/app/modules/painel/modules/roles/interfaces/role";

export class User {
  id: number;
  email?: string;
  nome?: string;
  cliente_id?: number;
  prestador_id?: number;
  tecnico_id?: number;
  admin?: boolean;

  roles?: Role[];
  prestador_servico?: Prestador;
  cliente?: Cliente;
}
